import React, { Component } from 'react'
import Loading from '../../../templates/UI/Loading/Loading'
import '../AvatarSurvey/Survey/Survey.css'
import _ from 'lodash'

import questionTypes from '../AvatarSurvey/Survey/data/avatarQuestionTypes'
import GlobalMacros from '../AvatarSurvey/Survey/GlobalMacros/GlobalMacros'
import AddQuestionTemplateModal from './Templates/AddQuestionTemplateModal'
import callAPI from '../../../helpers/callAPI'
import { Modal } from 'reactstrap'

class AvatarQuestionTemplate extends Component {
    //This component acts very similar to a survey that can only be one question long on this page.
    //The reason is that I wanted everything to behave as similarly to the survey as possible.
    //which will make it easer to add new question types in the future.
    //This way we can also use the same question components from questiontypes.js
    //and reuse a lot of the sql in the api.
    //the 'survey' can only be one question long though since we are only making templates
    //so after saving the question rather then selecing another question in the left panel like
    //on a survey it will just send you back to the template manager.
    // -TA 


    state = {
        dataLoaded: false,
        step: 0,
        stepList: [],
        addQuestionModalOpen: false,
        deleteModalOpen: false,
        survey: [], // This will hold the questions for the survey
    }

    componentDidMount() {
        const questionId = this.props.templateId;

        if (!isNaN(questionId)) {
            // Fetch the question data if the template ID is a number
            callAPI(`avatar/questionTemplate/${questionId}`, 'GET', {})
                .then((response) => {
                    this.setState({
                        ...this.state,
                        survey: [response] || [], // Assuming the API returns a survey array
                        dataLoaded: true,
                        step: 1, // Start at the first question
                    });
                })
                .catch((error) => {
                    console.error('Error fetching question data:', error);
                    this.setState({
                        ...this.state,
                        dataLoaded: true, // Still set dataLoaded to true to avoid loading spinner
                    });
                });
        } else {
            // If no valid questionId, just set dataLoaded to true
            this.setState({
                ...this.state,
                dataLoaded: true,
            });
        }
    }

    toggleAddQuestionModal = () => {
        this.setState({
            ...this.state,
            addQuestionModalOpen: !this.state.addQuestionModalOpen,
        })
    }

    handleAddQuestion = (question, type, name) => {
        // Get the max questionId
        let startQuestion =
            this.state.survey.length > 0
                ? Math.max.apply(
                    Math,
                    this.state.survey.map((question) => {
                        return question.questionId
                    })
                )
                : 0

        // Get options if any
        let options = questionTypes.find((questionType) => questionType.type === type).options !== undefined ? questionTypes.find((questionType) => questionType.type === type).options : []

        let newQuestion = {
            questionId: startQuestion + 1, //This is just a temporary ID for handling this ID until publication.
            dbQuestionId: 0, // This means it's a new question
            order: this.state.survey.length + 1,
            type: type, // text short
            placeholder: '',
            question: question,
            options: options,
            conditions: [],
            parameters: [],
            customMapping: 'N',
            question_name: name ? name : question, // Question name
        }

        let survey = _.cloneDeep(this.state.survey)

        survey.push(newQuestion)

        // Close the modal
        this.setState({
            ...this.state,
            survey: survey,
            addQuestionModalOpen: false,
            step: this.state.step + 1, // Move to the next question
        })
    }
    handleChange = (questionId) => (event) => {
        //Find the array location of the question at hand
        //let arrayIndex = this.state.survey.findIndex(x => x.questionId === questionId);
        //newSurvey[arrayIndex].question = event.target.value;
        let survey = _.cloneDeep(this.state.survey)
        if (event.target.name === 'question_name') {
            survey[0].question_name = event.target.value
        }
        if (event.target.name === '') {
            survey[0].question = event.target.value
        }


        //Update the question
        this.setState({
            ...this.state,
            survey: survey,
        })
    }

    handleChangePlaceholder = (questionId) => (event) => {
        //Find the array location of the question at hand
        //let arrayIndex = this.state.survey.findIndex(x => x.questionId === questionId);
        //newSurvey[arrayIndex].question = event.target.value;

        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)
        question.placeholder = event.target.value

        //Update the question
        this.setState({
            ...this.state,
            survey: survey,
        })
    }

    handleChangeDisclaimer = (questionId) => (event) => {
        //Find the array location of the question at hand
        //let arrayIndex = this.state.survey.findIndex(x => x.questionId === questionId);
        //newSurvey[arrayIndex].question = event.target.value;

        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)
        question.disclaimer = event.target.value

        //Update the question
        this.setState({
            ...this.state,
            survey: survey,
        })
    }

    handleChangeDisclaimerRequired = (questionId) => (event) => {
        //Find the array location of the question at hand
        //let arrayIndex = this.state.survey.findIndex(x => x.questionId === questionId);
        //newSurvey[arrayIndex].question = event.target.value;
        console.log('------------------------------------------')
        console.log('questionId', questionId, 'checked:', event.target.checked)
        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)
        question.disclaimerRequired = event.target.checked
        //Update the question
        this.setState({
            ...this.state,
            survey: survey,
        })
    }


    handleChangeCallToAction = (questionId) => (event) => {
        //Find the array location of the question at hand
        //let arrayIndex = this.state.survey.findIndex(x => x.questionId === questionId);
        //newSurvey[arrayIndex].question = event.target.value;

        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)
        question.callToAction = event.target.value

        //Update the question
        this.setState({
            ...this.state,
            survey: survey,
        })
    }

    handleChangeNegCallToAction = (questionId) => (event) => {
        //Find the array location of the question at hand
        //let arrayIndex = this.state.survey.findIndex(x => x.questionId === questionId);
        //newSurvey[arrayIndex].question = event.target.value;

        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)
        question.negCallToAction = event.target.value

        //Update the question
        this.setState({
            ...this.state,
            survey: survey,
        })
    }

    handleChangeCharLimit = (questionId) => (event) => {
        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)
        question.charLimit = event.target.value

        //Update the question
        this.setState({
            ...this.state,
            survey: survey,
        })
    }

    handleAddMultipleChoice = (questionId) => {
        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)

        // Get the highest optionId
        let tempQuestionId = 0
        if (question.options) {
            tempQuestionId =
                question.options.length > 0
                    ? Math.max.apply(
                        Math,
                        question.options.map((question) => {
                            return question.optionId ? question.optionId : 0
                        })
                    )
                    : 0
        } else {
            // Initialize the options array
            question.options = []
        }

        question.options.push({
            optionId: tempQuestionId + 1,
            dbOptionId: 0,
            value: '',
        })

        this.setState({
            ...this.state,
            survey: survey,
        })
    }

    handleRemoveMultipleChoice = (questionId, optionId) => {
        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)

        let optionIndex = question.options.findIndex((option) => option.optionId === optionId)

        question.options.splice(optionIndex, 1)

        this.setState({
            ...this.state,
            survey: survey,
        })
    }

    handleChangeMultipleChoice = (questionId, optionId) => (event) => {
        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)

        let option = question.options.find((option) => option.optionId === optionId)

        option.value = event.target.value

        this.setState({
            ...this.state,
            survey: survey,
        })
    }


    handleChangeRedirectList = (questionId, optionId, type) => (event) => {
        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)

        let option = question.options.find((option) => option.optionId === optionId)

        if (type === 'description') option.description = event.target.value
        if (type === 'url') option.url = event.target.value
        if (type === 'value') option.value = event.target.value
        if (type === 'image') option.image = event.target.files[0] ? event.target.files[0] : option.image

        this.setState({
            ...this.state,
            survey: survey,
        })
    }
    handleRemoveImage = (questionId, optionId) => (e) => {


        let survey = _.cloneDeep(this.state.survey)

        let question = survey.find((question) => question.questionId === questionId)

        let option = question.options.find((option) => option.optionId === optionId)

        option.image = ''

        this.setState({
            ...this.state,
            survey: survey,
        })
    }

    getQuestion = () => {
        let { step } = this.state
        let questionComponent = (
            <div className="text-center">
                <button className="btn btn-warning" onClick={this.toggleAddQuestionModal}>
                    + New Question Template
                </button>
                <AddQuestionTemplateModal open={this.state.addQuestionModalOpen} closeModal={this.toggleAddQuestionModal} handleAddQuestion={this.handleAddQuestion} />

            </div>
        )

        if (!isNaN(step)) {
            // let question = this.state.survey.find((question) => {
            //     return question.order === step
            // })
            let question = this.state.survey[0]
            if (question !== undefined) {
                let questionType = questionTypes.find((questionType) => {
                    return questionType.type === question.type
                })
                if (questionType) {
                    questionComponent = questionType.component(question, question.placeholder, this.handleChange, this.handleChangeDisclaimer, this.handleChangeDisclaimerRequired, this.handleChangeCallToAction, this.handleChangeNegCallToAction, this.handleChangePlaceholder, this.handleChangeCharLimit, this.handleAddMultipleChoice, this.handleChangeMultipleChoice, this.handleRemoveMultipleChoice, this.handleCustomEventMap, this.handleChangeRedirectList, this.handleRemoveImage)
                } else {
                    questionComponent = <div>No question for this type.</div>
                }
            }
        }

        return questionComponent
    }

    handleSaveSurvey = async (e) => {
        e.preventDefault()
        let survey = _.cloneDeep(this.state.survey)
        survey[0].question_name = survey[0].question_name ? survey[0].question_name : 'New Question Template'
        survey[0].question = survey[0].question ? survey[0].question : 'New Question Template'
        if (isNaN(this.props.templateId)) {
            await callAPI('avatar/questionTemplate', 'POST', {
                survey: this.state.survey,
            })
        } else {
            await callAPI(`avatar/questionTemplate/${this.props.templateId}`, 'PUT', {
                survey: this.state.survey,
            })
        }
        this.props.history.push('/avatar/questionTemplateManager')

    }

    handleDeleteSurvey = async (templateId) => {
        // Here we would delete the survey from the database
        if (this.state.deleteModalOpen) {
            await callAPI(`avatar/questionTemplate/${templateId}`, 'DELETE', {})
            this.props.history.push('/avatar/questionTemplateManager')
        } else {
            this.setState({
                ...this.state,
                deleteModalOpen: true,
            })
        }
    }

    render() {
        return this.state.dataLoaded ? (
            <>
                <div className="page-header d-flex align-items-center">
                    <h1 className="mb-h1">Avatar Question Template Editor</h1>
                </div>
                <div className="mb-survey d-flex align-items-center">

                    <div className="question-container m-auto d-flex flex-column">
                        {this.state.step > 0 ? ( //name
                            <div className="mb-2">
                                <div className='text-center font-weight-bold'>Template Name:</div>
                                <input
                                    width="50%"
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder="Searchable Template Name"
                                    name="question_name"
                                    value={this.state.survey[this.state.step - 1] ? this.state.survey[this.state.step - 1].question_name : ''}
                                    onChange={this.handleChange(this.state.survey[this.state.step - 1]?.questionId)}
                                />
                            </div>
                        ) : (
                            <div></div>
                        )}
                        {this.getQuestion()}
                        <hr></hr>
                        <div className="mt-2 d-flex justify-content-center">
                            <GlobalMacros />
                            {this.state.step > 0 ? (<>
                                <button className="btn btn-primary" onClick={this.handleSaveSurvey}>
                                    Save Template
                                </button>
                                <Modal isOpen={this.state.deleteModalOpen} toggle={() => this.setState({ ...this.state, deleteModalOpen: false })}>
                                    <div className="modal-header">
                                        <h5 className="modal-title">Delete Template</h5>
                                        <button type="button" className="close" onClick={() => this.setState({ ...this.state, deleteModalOpen: false })}>
                                            <span aria-hidden="true">x</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        Are you sure you want to delete this template? This action cannot be undone.
                                        Any linked questions will be unlinked and any further changes to them will need to be done manually.
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-secondary" onClick={() => this.setState({ ...this.state, deleteModalOpen: false })}>
                                            Cancel
                                        </button>
                                        <button className="btn btn-danger" onClick={() => this.handleDeleteSurvey(this.props.templateId)}>
                                            Delete
                                        </button>
                                    </div>
                                </Modal>
                                <button className="btn btn-danger ml-2" onClick={() => this.handleDeleteSurvey(this.props.templateId)}>
                                    Delete Template
                                </button>
                            </>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    </div>
                </div>
            </>) : (
            <div className="h-100">
                <div className="page-header d-flex align-items-center">
                    <h1 className="mb-h1">Avatar Question Template Editor</h1>
                </div>
                <Loading></Loading>
            </div>
        )
    }
}

export default AvatarQuestionTemplate
